import _toConsumableArray from "/home/ec2-user/salescircle-register/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/home/ec2-user/salescircle-register/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "/home/ec2-user/salescircle-register/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/ec2-user/salescircle-register/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/home/ec2-user/salescircle-register/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/ec2-user/salescircle-register/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/ec2-user/salescircle-register/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import CloudWatchLogs from "aws-sdk/clients/cloudwatchlogs";

var Logger = /*#__PURE__*/function () {
  /**
   * Constructor.
   *
   * @param accessKeyId     - AWS Access Key ID
   * @param secretAccessKey - AWS Secret Access Key
   * @param region          - AWS Region (e.g. ap-northeast-1)
   * @param logGroupName    - AWS CloudWatch Log Group Name
   */
  function Logger(accessKeyId, secretAccessKey, region, logGroupName) {
    _classCallCheck(this, Logger);

    this.accessKeyId = accessKeyId;
    this.secretAccessKey = secretAccessKey;
    this.region = region;
    this.logGroupName = logGroupName;

    _defineProperty(this, "levels", ["error"]);

    _defineProperty(this, "interval", 10000);

    _defineProperty(this, "muting", false);

    _defineProperty(this, "enabled", true);

    _defineProperty(this, "logStreamNameResolver", void 0);

    _defineProperty(this, "messageFormatter", void 0);

    _defineProperty(this, "client", void 0);

    _defineProperty(this, "storage", void 0);

    _defineProperty(this, "console", void 0);

    _defineProperty(this, "events", []);

    _defineProperty(this, "intervalId", void 0);
  }
  /**
   * Set level.
   *
   * @param levels - Reported error level
   */


  _createClass(Logger, [{
    key: "setLevels",
    value: function setLevels(levels) {
      this.levels = levels;
      return this;
    }
    /**
     * Set interval.
     *
     * @param interval - Interval milliseconds for sending logs
     */

  }, {
    key: "setInterval",
    value: function setInterval(interval) {
      this.interval = interval;
      return this;
    }
    /**
     * Mute logging in browser console.
     */

  }, {
    key: "mute",
    value: function mute() {
      this.muting = true;
      return this;
    }
    /**
     * Resume logging in browser console.
     */

  }, {
    key: "unmute",
    value: function unmute() {
      this.muting = false;
      return this;
    }
    /**
     * Enable collecting errors and sending to AWS CloudWatch.
     */

  }, {
    key: "enable",
    value: function enable() {
      this.enabled = true;
      return this;
    }
    /**
     * Disable collecting errors and sending to AWS CloudWatch.
     */

  }, {
    key: "disable",
    value: function disable() {
      this.enabled = false;
      return this;
    }
    /**
     * Bootstrap Logger.
     *
     * @param logStreamNameResolver - Resolve logStreamName for current user (e.g. Canvas Fingerprint)
     * @param messageFormatter      - Format message string from Error
     * @param Ctor
     * @param storage
     * @param globalConsole
     * @param eventTarget
     */

  }, {
    key: "install",
    value: function install() {
      var _this = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          logStreamNameResolver = _ref.logStreamNameResolver,
          messageFormatter = _ref.messageFormatter,
          _ref$ClientConstructo = _ref.ClientConstructor,
          Ctor = _ref$ClientConstructo === void 0 ? CloudWatchLogs : _ref$ClientConstructo,
          _ref$storage = _ref.storage,
          storage = _ref$storage === void 0 ? localStorage : _ref$storage,
          _ref$console = _ref.console,
          globalConsole = _ref$console === void 0 ? console : _ref$console,
          _ref$eventTarget = _ref.eventTarget,
          eventTarget = _ref$eventTarget === void 0 ? window : _ref$eventTarget;

      this.client = new Ctor({
        accessKeyId: this.accessKeyId,
        secretAccessKey: this.secretAccessKey,
        region: this.region
      });
      this.logStreamNameResolver = logStreamNameResolver;
      this.messageFormatter = messageFormatter;
      this.storage = storage; // Swap window.console.*() functions and overridden ones

      var originalConsole = {};

      var _iterator = _createForOfIteratorHelper(this.levels),
          _step;

      try {
        var _loop = function _loop() {
          var level = _step.value;
          originalConsole[level] = globalConsole[level].bind(globalConsole);

          globalConsole[level] = /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(message) {
              var _len,
                  args,
                  _key,
                  _args2 = arguments;

              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return _this.onError(new Error(message), {
                        type: "console",
                        level: level
                      });

                    case 2:
                      if (!_this.muting) {
                        for (_len = _args2.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                          args[_key - 1] = _args2[_key];
                        }

                        originalConsole[level].apply(originalConsole, [message].concat(args));
                      }

                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }));

            return function (_x2) {
              return _ref3.apply(this, arguments);
            };
          }();
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.console = originalConsole; // Listen "error" event on window (type="uncaught")

      eventTarget.addEventListener("error", /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(error) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.onError(error, {
                    type: "uncaught"
                  });

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }()); // Start timer that executes this.onInterval()

      this.intervalId = setInterval(this.onInterval.bind(this), this.interval);
    }
    /**
     * Queue a new error.
     *
     * @param e    - Error object
     * @param info - Extra Error Info (Consider using "type" field)
     */

  }, {
    key: "onError",
    value: function () {
      var _onError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, info) {
        var message;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!Logger.isValidError(e) || !this.enabled)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                if (!this.messageFormatter) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 5;
                return this.messageFormatter(e, info);

              case 5:
                _context3.t0 = _context3.sent;
                _context3.next = 9;
                break;

              case 8:
                _context3.t0 = // Custom formatter
                JSON.stringify(_objectSpread({
                  message: e.message
                }, info));

              case 9:
                message = _context3.t0;

                if (message) {
                  _context3.next = 12;
                  break;
                }

                return _context3.abrupt("return");

              case 12:
                this.events.push({
                  timestamp: new Date().getTime(),
                  message: message
                });

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onError(_x3, _x4) {
        return _onError.apply(this, arguments);
      }

      return onError;
    }()
    /**
     * Send queued errors.
     */

  }, {
    key: "onInterval",
    value: function () {
      var _onInterval = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;

        var pendingEvents, logStreamName, sequenceToken, params, nextSequenceToken, match, _yield$Promise, _yield$Promise$nextSe, _this$events;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.enabled) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                // Extract errors from queue
                pendingEvents = this.events.splice(0);

                if (pendingEvents.length) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return");

              case 5:
                _context4.next = 7;
                return this.getLogStreamName();

              case 7:
                logStreamName = _context4.sent;

                if (logStreamName) {
                  _context4.next = 10;
                  break;
                }

                return _context4.abrupt("return");

              case 10:
                _context4.next = 12;
                return this.getCache("sequenceToken");

              case 12:
                sequenceToken = _context4.sent;
                // Build parameters for PutLogEvents endpoint
                //   c.f. https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_PutLogEvents.html
                params = _objectSpread({
                  logEvents: pendingEvents,
                  logGroupName: this.logGroupName,
                  logStreamName: logStreamName
                }, sequenceToken ? {
                  sequenceToken: sequenceToken
                } : undefined);
                nextSequenceToken = undefined, match = null;
                _context4.prev = 15;
                _context4.next = 18;
                return new Promise(function (resolve, reject) {
                  _this2.getClient().putLogEvents(params, function (err, data) {
                    return err ? reject(err) : resolve(data);
                  });
                });

              case 18:
                _yield$Promise = _context4.sent;
                _yield$Promise$nextSe = _yield$Promise.nextSequenceToken;
                nextSequenceToken = _yield$Promise$nextSe === void 0 ? undefined : _yield$Promise$nextSe;
                _context4.next = 30;
                break;

              case 23:
                _context4.prev = 23;
                _context4.t0 = _context4["catch"](15);

                if (!(!Logger.isValidError(_context4.t0) || _context4.t0.code !== "InvalidSequenceTokenException" || !(match = _context4.t0.message.match(/The next expected sequenceToken is: (\w+)/)))) {
                  _context4.next = 30;
                  break;
                }

                // Print error to original console and reset states
                this.getConsole().error(_context4.t0);
                _context4.next = 29;
                return this.refresh();

              case 29:
                return _context4.abrupt("return");

              case 30:
                // Recover from InvalidSequenceTokenException error message
                if (match) {
                  nextSequenceToken = match[1];
                } // Cache fresh "nextSequenceToken"


                if (!nextSequenceToken) {
                  _context4.next = 34;
                  break;
                }

                _context4.next = 34;
                return this.setCache("sequenceToken", nextSequenceToken);

              case 34:
                // Immediately retry after recovery
                if (match) {
                  (_this$events = this.events).push.apply(_this$events, _toConsumableArray(pendingEvents));

                  setTimeout(this.onInterval, 0);
                }

              case 35:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[15, 23]]);
      }));

      function onInterval() {
        return _onInterval.apply(this, arguments);
      }

      return onInterval;
    }()
  }, {
    key: "getClient",
    value: function getClient() {
      if (!this.client) {
        throw new Error("Not yet installed");
      }

      return this.client;
    }
  }, {
    key: "getStorage",
    value: function getStorage() {
      if (!this.storage) {
        throw new Error("Not yet installed");
      }

      return this.storage;
    }
  }, {
    key: "getConsole",
    value: function getConsole() {
      if (!this.console) {
        throw new Error("Not yet installed");
      }

      return this.console;
    }
  }, {
    key: "setCache",
    value: function () {
      var _setCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(key, value) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.getStorage().setItem("".concat(Logger.namespace, ":").concat(key), value));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setCache(_x5, _x6) {
        return _setCache.apply(this, arguments);
      }

      return setCache;
    }()
  }, {
    key: "getCache",
    value: function () {
      var _getCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(key) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.getStorage().getItem("".concat(Logger.namespace, ":").concat(key)));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getCache(_x7) {
        return _getCache.apply(this, arguments);
      }

      return getCache;
    }()
  }, {
    key: "deleteCache",
    value: function () {
      var _deleteCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(key) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.getStorage().removeItem("".concat(Logger.namespace, ":").concat(key)));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function deleteCache(_x8) {
        return _deleteCache.apply(this, arguments);
      }

      return deleteCache;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.deleteCache("logStreamName");

              case 2:
                _context8.next = 4;
                return this.deleteCache("sequenceToken");

              case 4:
                this.events.splice(0);

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "getLogStreamName",
    value: function () {
      var _getLogStreamName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _this3 = this;

        var retrieved, params;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.getCache("logStreamName");

              case 2:
                retrieved = _context9.sent;

                if (!retrieved) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt("return", retrieved);

              case 5:
                _context9.t0 = this.logGroupName;
                _context9.t2 = this.logStreamNameResolver;

                if (!_context9.t2) {
                  _context9.next = 11;
                  break;
                }

                _context9.next = 10;
                return this.logStreamNameResolver();

              case 10:
                _context9.t2 = _context9.sent;

              case 11:
                _context9.t1 = _context9.t2;

                if (_context9.t1) {
                  _context9.next = 14;
                  break;
                }

                _context9.t1 = // Resolve for current user (e.g. Canvas Fingerprint)
                Logger.defaultLogStreamName;

              case 14:
                _context9.t3 = _context9.t1;
                params = {
                  logGroupName: _context9.t0,
                  logStreamName: _context9.t3
                };
                _context9.prev = 16;
                _context9.next = 19;
                return new Promise(function (resolve, reject) {
                  _this3.getClient().createLogStream(params, function (err, data) {
                    return err ? reject(err) : resolve(data);
                  });
                });

              case 19:
                _context9.next = 28;
                break;

              case 21:
                _context9.prev = 21;
                _context9.t4 = _context9["catch"](16);

                if (!(!Logger.isValidError(_context9.t4) || _context9.t4.code !== "ResourceAlreadyExistsException")) {
                  _context9.next = 28;
                  break;
                }

                // Print error to original console and reset states
                this.getConsole().error(_context9.t4);
                _context9.next = 27;
                return this.refresh();

              case 27:
                return _context9.abrupt("return", null);

              case 28:
                _context9.next = 30;
                return this.setCache("logStreamName", params.logStreamName);

              case 30:
                return _context9.abrupt("return", params.logStreamName);

              case 31:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[16, 21]]);
      }));

      function getLogStreamName() {
        return _getLogStreamName.apply(this, arguments);
      }

      return getLogStreamName;
    }()
  }], [{
    key: "isValidError",
    value: function isValidError(value) {
      return value && typeof value.message === "string";
    }
  }]);

  return Logger;
}();

export { Logger as default };

_defineProperty(Logger, "namespace", "CloudWatchFrontLogger");

_defineProperty(Logger, "defaultLogStreamName", "anonymous");